<template>
    <nav class="navbar bg-primary">
        <div class="d-flex navbar-brand text-white item-c">

<img src="@/assets/logo.png" alt="" class="d-inline-block align-text-top mx-2" height="35">
<span class="text-title">Wolf Gym </span>
 - {{username}}

</div>
       

        <div class="d-flex">

            <router-link :to="{name:'register'}"> 
              <button class="btn btn-outline-info mx-2" >             
                <i class="far fa-address-card"></i>
                </button>
            </router-link>

            <button class="btn btn-outline-info mx-2" @click="onLogout">
                
                <i class="fa fa-sign-out-alt"></i>
            </button>
        
            
        </div>
        
    </nav>
</template>

<script>
import Swal from 'sweetalert2';
import { useRouter } from 'vue-router';
import useAuth from '../../auth/composables/useAuth';

export default{
    setup(){
        const router = useRouter()
       const{username, logout} = useAuth()

       return{
      username,
      onLogout: ()=>{

    
Swal.fire({
  title: "Estas seguro que quieres cerrar sesión?",
 
  showCancelButton: true,
  cancelButtonText:'No',
  confirmButtonText: "Si",
  
  
}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
  
    Swal.fire("Sesión cerrada!", "", "success");
    router.push({ name: 'login'})
        logout()
  }
});

       
      }   
    }
    }
    
}


</script>

<style >
.item-c{
    align-items: center

}
.text-title{
    font-size: 25px;
    font-weight: 800 !important;
    color: white !important;
  
    
    -webkit-text-fill-color:white;
   


}
</style>